import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import CourseCard from "@/components/CourseCard";
import { Button } from "@/components/ui/button";

export default function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [courses, setCourses] = useState([]);
  const [sub, setSub] = useState("");

  useEffect(() => {
    setCategory(null);
    setSub("");
    api.get("/categories").then((r) => setCategory(r.data.find((c) => c.slug === slug) || null)).catch(() => {});
    api.get("/courses", { params: { category: slug, limit: 50 } }).then((r) => setCourses(r.data.items)).catch(() => {});
  }, [slug]);

  const filtered = sub ? courses.filter((c) => c.subcategory === sub) : courses;

  return (
    <div className="bg-navy-base min-h-screen" data-testid="category-page">
      <SEO title={`${category?.name || "Courses"} in Jorhat | XTM TECHNOLOGIES`}
        description={category?.tagline || "Explore programs at XTM FutureSkills Academy Jorhat."} />
      <section className="relative hero-glow">
        <div className="absolute inset-0 cyber-grid opacity-40" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-orange-400 mb-2">Category</div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mb-4" data-testid="category-title">
            {category?.name || "…"}
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl">{category?.tagline}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        {category?.subcategories?.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-10" data-testid="subcategory-filters">
            <Button onClick={() => setSub("")} variant={sub === "" ? "default" : "outline"}
              className={sub === "" ? "bg-orange-600 text-white rounded-full" : "border-white/20 text-slate-300 hover:bg-white/5 rounded-full"}
              data-testid="subcat-all">All</Button>
            {category.subcategories.map((s) => (
              <Button key={s} onClick={() => setSub(s)} variant={sub === s ? "default" : "outline"}
                className={sub === s ? "bg-orange-600 text-white rounded-full" : "border-white/20 text-slate-300 hover:bg-white/5 rounded-full"}
                data-testid={`subcat-${s.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>{s}</Button>
            ))}
          </div>
        )}
        {filtered.length === 0 ? (
          <p className="text-slate-400 text-sm py-16 text-center" data-testid="category-empty">Programs in this track are being configured. Contact us for the latest offerings.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="category-courses-grid">
            {filtered.map((c) => <CourseCard key={c.slug} course={c} />)}
          </div>
        )}
      </section>
    </div>
  );
}
